import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const ProductsSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Our Products',
      products: [
        {
          title: 'Labels',
          description: 'Woven, printed, care and heat transfer labels.',
          image: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/i574nzka_WhatsApp%20Image%202026-05-30%20at%2017.06.01%20%283%29.jpeg',
          slug: 'branding-labels'
        },
        {
          title: 'Hangtags',
          description: 'Custom hangtags and printed tags.',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/a6pbakjk_karton-etiket-6.jpg',
          slug: 'hang-tags'
        },
        {
          title: 'Patches',
          description: 'Embroidery, leather and silicone patches.',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/1461hl29_diger-etiket-2.jpg',
          slug: 'care-composition'
        },
        {
          title: 'Packaging',
          description: 'Custom boxes, polybags and packaging.',
          image: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/cb1fhqlb_karton-kutu-3.jpg',
          slug: 'packaging'
        }
      ],
      cta: {
        quote: 'Get a Quote Within 24 Hours',
        samples: 'Request Samples'
      }
    },
    tr: {
      title: 'Ürünlerimiz',
      products: [
        {
          title: 'Etiketler',
          description: 'Dokuma, baskılı, bakım ve ısı transfer etiketleri.',
          image: 'https://customer-assets.emergentagent.com/job_63ec9bab-e8ef-40cf-ae2e-d7c59bba5a35/artifacts/i574nzka_WhatsApp%20Image%202026-05-30%20at%2017.06.01%20%283%29.jpeg',
          slug: 'branding-labels'
        },
        {
          title: 'Karton Etiketler',
          description: 'Özel karton etiketler ve baskılı etiketler.',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/a6pbakjk_karton-etiket-6.jpg',
          slug: 'hang-tags'
        },
        {
          title: 'Yamalar',
          description: 'Nakış, deri ve silikon yamalar.',
          image: 'https://customer-assets.emergentagent.com/job_2626b563-ef30-408d-8380-25533662d40f/artifacts/1461hl29_diger-etiket-2.jpg',
          slug: 'care-composition'
        },
        {
          title: 'Ambalaj',
          description: 'Özel kutular, poli torbalar ve ambalaj.',
          image: 'https://customer-assets.emergentagent.com/job_etiteks-textile/artifacts/cb1fhqlb_karton-kutu-3.jpg',
          slug: 'packaging'
        }
      ],
      cta: {
        quote: '24 Saat İçinde Teklif Alın',
        samples: 'Numune Talep Edin'
      }
    }
  };

  const t = content[language];

  return (
    <section id="products" data-testid="home-products-section" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <h2 data-testid="home-products-title" className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16">
          {t.title}
        </h2>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {t.products.map((product, index) => (
            <Link
              key={index}
              to={`/products/${product.slug}`}
              data-testid={`home-product-${product.slug}`}
              className="group block"
            >
              {/* Image Container */}
              <div className="bg-gray-100 rounded-lg overflow-hidden mb-4 aspect-[4/3]">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Text */}
              <h3 data-testid={`home-product-title-${product.slug}`} className="text-xl font-bold text-gray-900 mb-1 group-hover:text-teal-600 transition-colors">
                {product.title}
              </h3>
              <p data-testid={`home-product-description-${product.slug}`} className="text-gray-500">
                {product.description}
              </p>
            </Link>
          ))}
        </div>

        {/* CTA Section */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            data-testid="home-products-get-quote"
            className="px-6 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
          >
            {t.cta.quote}
          </Link>
          <Link
            to="/contact"
            data-testid="home-products-request-samples"
            className="px-6 py-2.5 bg-gray-900 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors"
          >
            {t.cta.samples}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
